import { createAction } from '@reduxjs/toolkit';
import type { Map as ImMap, RecordOf } from 'immutable';

import type { RootUiData } from './rootUiTypes';

export const createDialog = createAction<RecordOf<RootUiData>>('CREATE_DIALOG');
export const removeDialog = createAction(
  'REMOVE_DIALOG',
  (dialogId?: string | 0, meta?: { animate?: boolean; onlyIfHidden?: boolean }) => ({
    payload: dialogId,
    meta,
  }),
);
export const showNextDialog = createAction('SHOW_NEXT_DIALOG');
export const updateDialogProps = createAction<{ id: string; props: ImMap<string, any> }>('UPDATE_DIALOG_PROPS');

/**
 * Reorder queued dialogs by moving a queued dialog before another queued dialog.
 * No-ops if either dialog id is not found in the queued list.
 */
export const moveQueuedDialogBefore = createAction<{ id: string; beforeId: string }>('MOVE_QUEUED_DIALOG_BEFORE');
